(() => {
  "use strict";

  const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
  const RENDER_MAX_SIDE = 1800;
  const BRAND_W = 1200;
  const BRAND_H = 1800;
  const WRAP_W = 1200;
  const WRAP_H = 1650;
  const CANONICAL_FORMATS = { portrait: 3 / 4, landscape: 3 / 2, square: 1 };

  const ROOM_VARIANTS = {
    portrait: { w: 1200, h: 1800, quad: [[278, 329], [835, 332], [833, 1167], [276, 1165]], bleed: 3, arat: .667 },
    landscape: { w: 1280, h: 853, quad: [[294.5, 144.5], [1022.1, 143], [1027, 655.6], [284.1, 652.5]], bleed: 4, arat: 1.466, edgeStroke: false },
    square: { w: 1254, h: 1254, quad: [[326.8, 303.7], [930.4, 305.9], [929.5, 956.1], [318.5, 953.6]], bleed: 3, arat: 1, edgeStroke: false },
  };

  const FLOOR_VARIANTS = {
    portrait: { w: 908, h: 1362, quad: [[213, 273], [781, 278], [710, 1132], [133, 1075]], bleed: 3, shade: true, bright: 1.138 },
    landscape: { w: 1280, h: 853, quad: [[244, 129.7], [1068, 149.7], [1043.5, 753.7], [208.5, 687.5]], bleed: 5, arat: 1.407, edgeStroke: false },
    square: { w: 1254, h: 1254, quad: [[287.8, 279.8], [1003.3, 293.8], [970.1, 1064.5], [236.9, 1007.9]], bleed: 3, arat: 1, edgeStroke: false },
  };

  const EXTRA_SCENES = [
    { key: "tube", label: "Poster tube roll", full: [[508.8, 292.7], [1064.4, 583.5], [612.9, 920.9], [48.7, 625.7]], vis: [[429.5, 350.1], [979.5, 646.9], [612.9, 920.9], [48.7, 625.7]], w: 1500, h: 1140, wp: 249 },
    { key: "floater-white", label: "White floater", portrait: { quad: [[222.6, 160.5], [880.1, 245.8], [880.1, 1243.9], [222.9, 1275.2]], w: 1085, h: 1450 }, landscape: { quad: [[256.8, 108.5], [1327.9, 200.3], [1327.9, 859.5], [256.9, 896.7]], w: 1536, h: 1024 }, square: { quad: [[213.9, 116.8], [1081.6, 161.2], [1081.5, 1066.2], [213.1, 1098.4]], w: 1254, h: 1254, arat: .921 } },
    { key: "floater-walnut", label: "Walnut floater", portrait: { quad: [[239, 167.6], [881, 251.4], [883, 1239.8], [242, 1272.8]], w: 1085, h: 1450 }, landscape: { quad: [[276, 116], [1321, 195], [1321, 842], [276, 884]], w: 1536, h: 1024 }, square: { quad: [[210, 136], [1075, 173], [1075, 1048], [210, 1071]], w: 1254, h: 1254, arat: .956 } },
    { key: "floater-gold", label: "Gold floater", portrait: { quad: [[226.3, 157.3], [884.1, 245.8], [884.1, 1254], [223.6, 1284.9]], w: 1085, h: 1450 }, landscape: { quad: [[242.2, 109.6], [1332, 189.4], [1331.7, 848.6], [241.7, 888.1]], w: 1536, h: 1024 }, square: { quad: [[223.5, 131.1], [1071.3, 162.8], [1070.9, 1060.7], [224.2, 1088.6]], w: 1254, h: 1254, arat: .914 } },
    { key: "floater-natural", label: "Natural floater", portrait: { quad: [[221.5, 164.1], [886.2, 250.9], [886.2, 1244.5], [221.5, 1277.9]], w: 1085, h: 1450 }, landscape: { quad: [[270.3, 119.1], [1317.1, 201], [1317.1, 838.6], [272.1, 872.6]], w: 1536, h: 1024 }, square: { quad: [[209.6, 120.3], [1082.9, 160.9], [1081.9, 1065.1], [210.8, 1096.5]], w: 1254, h: 1254, arat: .928 } },
    { key: "floater-black", label: "Black floater", portrait: { quad: [[237.5, 164.6], [877.6, 238.1], [878.5, 1203], [237.3, 1236.4]], w: 1082, h: 1454 }, landscape: { quad: [[275, 112.9], [1320.1, 192.6], [1320.1, 841.9], [275.5, 881.4]], w: 1536, h: 1024 }, square: { quad: [[224.5, 143.4], [1075.1, 181.3], [1075.1, 1037.2], [224.8, 1067.9]], w: 1254, h: 1254, arat: .956 } },
    { key: "floater-oak", label: "Oak floater", portrait: { quad: [[229.1, 148.7], [893.5, 240.3], [890.9, 1277.8], [227.7, 1314.5]], w: 1085, h: 1450 }, landscape: { quad: [[262.8, 122.9], [1321.8, 202.1], [1322, 849.5], [262.3, 885]], w: 1536, h: 1024 }, square: { quad: [[242.7, 135], [1082, 167.4], [1081.8, 1037.3], [243.2, 1065.5]], w: 1254, h: 1254, arat: .933 } },
  ];

  function solve8(a, b) {
    const matrix = a.map((row, index) => row.concat([b[index]]));
    for (let column = 0; column < 8; column += 1) {
      let pivot = column;
      for (let row = column + 1; row < 8; row += 1) {
        if (Math.abs(matrix[row][column]) > Math.abs(matrix[pivot][column])) pivot = row;
      }
      [matrix[column], matrix[pivot]] = [matrix[pivot], matrix[column]];
      for (let row = 0; row < 8; row += 1) {
        if (row === column) continue;
        const factor = matrix[row][column] / matrix[column][column];
        for (let item = column; item < 9; item += 1) matrix[row][item] -= factor * matrix[column][item];
      }
    }
    return matrix.map((row, index) => row[8] / row[index]);
  }

  function homography(destination) {
    const source = [[0, 0], [1, 0], [1, 1], [0, 1]];
    const a = [];
    const b = [];
    for (let index = 0; index < 4; index += 1) {
      const [u, v] = source[index];
      const [x, y] = destination[index];
      a.push([u, v, 1, 0, 0, 0, -x * u, -x * v]); b.push(x);
      a.push([0, 0, 0, u, v, 1, -y * u, -y * v]); b.push(y);
    }
    const h = solve8(a, b);
    return [h[0], h[1], h[2], h[3], h[4], h[5], h[6], h[7], 1];
  }

  function inverse3(matrix) {
    const [a, b, c, d, e, f, g, h, i] = matrix;
    const A = e * i - f * h;
    const B = c * h - b * i;
    const C = b * f - c * e;
    const D = f * g - d * i;
    const E = a * i - c * g;
    const F = c * d - a * f;
    const G = d * h - e * g;
    const H = b * g - a * h;
    const I = a * e - b * d;
    const determinant = a * A + b * D + c * G;
    return [A / determinant, B / determinant, C / determinant, D / determinant, E / determinant, F / determinant, G / determinant, H / determinant, I / determinant];
  }

  function expandQuad(quad, pixels) {
    const cx = quad.reduce((sum, point) => sum + point[0], 0) / 4;
    const cy = quad.reduce((sum, point) => sum + point[1], 0) / 4;
    return quad.map(([x, y]) => {
      const dx = x - cx;
      const dy = y - cy;
      const distance = Math.hypot(dx, dy) || 1;
      return [x + (dx / distance) * pixels, y + (dy / distance) * pixels];
    });
  }

  const GLR = (() => {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl2", { antialias: true, alpha: true })
      || canvas.getContext("webgl", { antialias: true, alpha: true });
    if (!gl) return null;
    const isWebGl2 = typeof WebGL2RenderingContext !== "undefined" && gl instanceof WebGL2RenderingContext;
    const vertexSource = "attribute vec2 aPos;uniform vec2 uRes;varying vec2 vScene;void main(){vScene=aPos;vec2 c=aPos/uRes*2.0-1.0;gl_Position=vec4(c.x,-c.y,0.0,1.0);}";
    const fragmentSource = "precision highp float;varying vec2 vScene;uniform mat3 uHinv;uniform sampler2D uTex;uniform float uShade;void main(){vec3 s=uHinv*vec3(vScene,1.0);vec2 uv=clamp(s.xy/s.z,0.0,1.0);vec4 c=texture2D(uTex,uv);gl_FragColor=vec4(c.rgb*uShade,1.0);}";
    const shader = (type, source) => {
      const item = gl.createShader(type);
      gl.shaderSource(item, source);
      gl.compileShader(item);
      if (!gl.getShaderParameter(item, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(item));
      return item;
    };
    const program = gl.createProgram();
    gl.attachShader(program, shader(gl.VERTEX_SHADER, vertexSource));
    gl.attachShader(program, shader(gl.FRAGMENT_SHADER, fragmentSource));
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) return null;
    const aPos = gl.getAttribLocation(program, "aPos");
    const uRes = gl.getUniformLocation(program, "uRes");
    const uHinv = gl.getUniformLocation(program, "uHinv");
    const uShade = gl.getUniformLocation(program, "uShade");
    const buffer = gl.createBuffer();
    const maxDim = Math.min(gl.getParameter(gl.MAX_RENDERBUFFER_SIZE) || 4096, gl.getParameter(gl.MAX_TEXTURE_SIZE) || 4096);
    const makeTexture = (image) => {
      const texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      if (isWebGl2) {
        gl.generateMipmap(gl.TEXTURE_2D);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      } else {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      }
      return texture;
    };
    const render = (width, height, items) => {
      canvas.width = width;
      canvas.height = height;
      gl.viewport(0, 0, width, height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.useProgram(program);
      gl.uniform2f(uRes, width, height);
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.enableVertexAttribArray(aPos);
      gl.vertexAttribPointer(aPos, 2, gl.FLOAT, false, 0, 0);
      for (const item of items) {
        const inverse = inverse3(homography(item.quad));
        gl.uniformMatrix3fv(uHinv, false, [inverse[0], inverse[3], inverse[6], inverse[1], inverse[4], inverse[7], inverse[2], inverse[5], inverse[8]]);
        gl.uniform1f(uShade, item.shade);
        gl.bindTexture(gl.TEXTURE_2D, item.texture);
        const quad = item.quad;
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([quad[0][0], quad[0][1], quad[1][0], quad[1][1], quad[2][0], quad[2][1], quad[3][0], quad[3][1]]), gl.STREAM_DRAW);
        gl.drawArrays(gl.TRIANGLE_FAN, 0, 4);
      }
      return canvas;
    };
    return { gl, makeTexture, maxDim, render };
  })();

  function canvas(width, height) {
    const item = document.createElement("canvas");
    item.width = width;
    item.height = height;
    return item;
  }

  function orientation(poster) {
    const ratio = poster.width / poster.height;
    if (ratio > 1.08) return "landscape";
    if (ratio < .92) return "portrait";
    return "square";
  }

  function coverCrop(poster, target) {
    const ratio = poster.width / poster.height;
    let sx = 0;
    let sy = 0;
    let sw = poster.width;
    let sh = poster.height;
    if (ratio > target) {
      sw = Math.max(1, Math.round(poster.height * target));
      sx = Math.max(0, Math.round((poster.width - sw) / 2));
    } else if (ratio < target) {
      sh = Math.max(1, Math.round(poster.width / target));
      sy = Math.max(0, Math.round((poster.height - sh) / 2));
    }
    const output = canvas(sw, sh);
    output.getContext("2d").drawImage(poster, sx, sy, sw, sh, 0, 0, sw, sh);
    return output;
  }

  function sceneCrop(poster, aspect) {
    const canonical = CANONICAL_FORMATS[orientation(poster)];
    const base = coverCrop(poster, canonical);
    if (!aspect || Math.abs(aspect / canonical - 1) < .02) return base;
    return coverCrop(base, aspect);
  }

  function quadPath(context, quad) {
    context.beginPath();
    context.moveTo(quad[0][0], quad[0][1]);
    for (let index = 1; index < 4; index += 1) context.lineTo(quad[index][0], quad[index][1]);
    context.closePath();
  }

  function stripWarp(context, image, x0, x1, topLeft, topRight, bottomLeft, bottomRight) {
    const width = Math.round(x1 - x0);
    for (let index = 0; index < width; index += 1) {
      const progress = index / width;
      const top = topLeft + (topRight - topLeft) * progress;
      const bottom = bottomLeft + (bottomRight - bottomLeft) * progress;
      context.drawImage(image, progress * image.width, 0, Math.max(image.width / width, .5), image.height, x0 + index, top, 1.05, bottom - top);
    }
  }

  function warpIntoQuad(context, poster, quad, width, height, bleed = 4, aspect) {
    const crop = sceneCrop(poster, aspect);
    const destination = expandQuad(quad, bleed);
    context.save();
    quadPath(context, quad);
    context.clip();
    if (GLR) {
      const texture = GLR.makeTexture(crop);
      const scale = Math.min(2, GLR.maxDim / Math.max(width, height));
      const rendered = GLR.render(Math.round(width * scale), Math.round(height * scale), [{ texture, quad: destination.map((point) => [point[0] * scale, point[1] * scale]), shade: 1 }]);
      context.drawImage(rendered, 0, 0, width, height);
      GLR.gl.deleteTexture(texture);
    } else {
      stripWarp(context, crop, destination[0][0], destination[1][0], destination[0][1], destination[1][1], destination[3][1], destination[2][1]);
    }
    context.restore();
  }

  function wrapGeometry(posterWidth, posterHeight, width, height) {
    const aspect = posterHeight / posterWidth;
    const halfHeight = aspect / 2;
    const depth = .15;
    const rotation = 26 * Math.PI / 180;
    const distance = 5.5;
    const project = (x, y, z) => {
      const xr = x * Math.cos(rotation) + z * Math.sin(rotation);
      const zr = -x * Math.sin(rotation) + z * Math.cos(rotation);
      const scale = distance / (distance - zr);
      return [xr * scale, y * scale];
    };
    const points = { fTL: project(-.5, halfHeight, 0), fTR: project(.5, halfHeight, 0), fBR: project(.5, -halfHeight, 0), fBL: project(-.5, -halfHeight, 0), sTL: project(-.5, halfHeight, -depth), sBL: project(-.5, -halfHeight, -depth) };
    const xs = Object.values(points).map((point) => point[0]);
    const ys = Object.values(points).map((point) => point[1]);
    const minX = Math.min(...xs);
    const maxX = Math.max(...xs);
    const minY = Math.min(...ys);
    const maxY = Math.max(...ys);
    const scale = Math.min(width * .8 / (maxX - minX), height * .8 / (maxY - minY));
    const cx = width / 2 - (minX + maxX) / 2 * scale;
    const cy = height / 2 + (minY + maxY) / 2 * scale;
    const point = (key) => [cx + points[key][0] * scale, cy - points[key][1] * scale];
    return { front: [point("fTL"), point("fTR"), point("fBR"), point("fBL")], side: [point("sTL"), point("fTL"), point("fBL"), point("sBL")] };
  }

  function renderFlat(poster) {
    const output = canvas(poster.width, poster.height);
    const context = output.getContext("2d");
    context.fillStyle = "#fff";
    context.fillRect(0, 0, output.width, output.height);
    context.drawImage(poster, 0, 0);
    return output;
  }

  function renderBranded(poster, assets) {
    const output = canvas(BRAND_W, BRAND_H);
    const context = output.getContext("2d");
    context.fillStyle = "#fff";
    context.fillRect(0, 0, output.width, output.height);
    const logo = assets.logo;
    const logoWidth = Math.round(BRAND_W * .475);
    const logoHeight = Math.round(logo.naturalHeight * logoWidth / logo.naturalWidth);
    context.drawImage(logo, (BRAND_W - logoWidth) / 2, BRAND_H * .035, logoWidth, logoHeight);
    const scale = Math.min(BRAND_W * .72 / poster.width, BRAND_H * .755 / poster.height);
    const width = Math.round(poster.width * scale);
    const height = Math.round(poster.height * scale);
    const x = Math.round((BRAND_W - width) / 2);
    const y = Math.round(BRAND_H * .20);
    context.save();
    context.filter = `blur(${Math.round(BRAND_W * .011)}px)`;
    context.fillStyle = "rgba(0,0,0,.32)";
    context.fillRect(x + BRAND_W * .008, y + BRAND_W * .01, width, height);
    context.restore();
    context.fillStyle = "#141414";
    context.fillRect(x - 4, y - 4, width + 8, height + 8);
    context.drawImage(poster, x, y, width, height);
    return output;
  }

  function renderWrap(poster) {
    const output = canvas(WRAP_W, WRAP_H);
    const context = output.getContext("2d");
    context.fillStyle = "#fff";
    context.fillRect(0, 0, output.width, output.height);
    const geometry = wrapGeometry(poster.width, poster.height, output.width, output.height);
    const front = geometry.front;
    const side = geometry.side;
    const offset = output.width * .012;
    context.save();
    context.filter = `blur(${Math.round(output.width * .016)}px)`;
    context.fillStyle = "rgba(0,0,0,.36)";
    const silhouette = [side[0], front[1], front[2], side[3]];
    context.beginPath();
    context.moveTo(silhouette[0][0] + offset, silhouette[0][1] + offset);
    silhouette.slice(1).forEach((point) => context.lineTo(point[0] + offset, point[1] + offset));
    context.closePath();
    context.fill();
    context.restore();
    const stripWidth = Math.max(14, Math.round(poster.width * .055));
    const strip = canvas(stripWidth, poster.height);
    const stripContext = strip.getContext("2d");
    stripContext.translate(stripWidth, 0);
    stripContext.scale(-1, 1);
    stripContext.drawImage(poster, 0, 0, stripWidth, poster.height, 0, 0, stripWidth, poster.height);
    stripContext.setTransform(1, 0, 0, 1, 0, 0);
    stripContext.fillStyle = "rgba(0,0,0,.52)";
    stripContext.fillRect(0, 0, strip.width, strip.height);
    if (GLR) {
      const scale = Math.min(2, GLR.maxDim / Math.max(output.width, output.height));
      const sideTexture = GLR.makeTexture(strip);
      const frontTexture = GLR.makeTexture(poster);
      const scaled = (quad) => quad.map((point) => [point[0] * scale, point[1] * scale]);
      const rendered = GLR.render(Math.round(output.width * scale), Math.round(output.height * scale), [
        { texture: sideTexture, quad: scaled(expandQuad(side, 1.4)), shade: 1 },
        { texture: frontTexture, quad: scaled(expandQuad(front, .6)), shade: 1 },
      ]);
      context.drawImage(rendered, 0, 0, output.width, output.height);
      GLR.gl.deleteTexture(sideTexture);
      GLR.gl.deleteTexture(frontTexture);
    } else {
      stripWarp(context, strip, side[0][0], side[1][0], side[0][1], side[1][1], side[3][1], side[2][1]);
      stripWarp(context, poster, front[0][0], front[1][0], front[0][1], front[1][1], front[3][1], front[2][1]);
    }
    return output;
  }

  function renderPhotoScene(poster, assets, kind) {
    const key = orientation(poster);
    const spec = kind === "room" ? ROOM_VARIANTS[key] : FLOOR_VARIANTS[key];
    const output = canvas(spec.w, spec.h);
    const context = output.getContext("2d");
    const background = assets[`${kind}.${key}`];
    context.drawImage(background, 0, 0, output.width, output.height);
    warpIntoQuad(context, poster, spec.quad, output.width, output.height, spec.bleed, spec.arat);
    if (spec.shade) {
      context.save();
      quadPath(context, spec.quad);
      context.clip();
      context.filter = `brightness(${spec.bright})`;
      context.globalCompositeOperation = "multiply";
      context.drawImage(background, 0, 0, output.width, output.height);
      context.restore();
    }
    if (spec.edgeStroke !== false) {
      context.save();
      context.filter = "blur(1.5px)";
      context.strokeStyle = "rgba(0,0,0,.3)";
      context.lineWidth = 3;
      quadPath(context, spec.quad);
      context.stroke();
      context.restore();
    }
    return output;
  }

  function renderFloater(poster, assets, scene) {
    const key = orientation(poster);
    const spec = scene[key];
    const output = canvas(spec.w, spec.h);
    const context = output.getContext("2d");
    context.drawImage(assets[`${scene.key}.${key}`], 0, 0, output.width, output.height);
    warpIntoQuad(context, poster, spec.quad, output.width, output.height, 5, spec.arat);
    context.save();
    quadPath(context, spec.quad);
    context.clip();
    const gradient = context.createLinearGradient(spec.quad[0][0], 0, spec.quad[1][0], 0);
    gradient.addColorStop(0, "rgba(0,0,0,0)");
    gradient.addColorStop(1, "rgba(0,0,0,.12)");
    context.fillStyle = gradient;
    context.fillRect(0, 0, output.width, output.height);
    context.restore();
    return output;
  }

  function renderTube(poster, assets, scene) {
    const output = canvas(scene.w, scene.h);
    const context = output.getContext("2d");
    const background = assets.tube;
    context.drawImage(background, 0, 0, output.width, output.height);
    const square = Math.min(poster.width, poster.height);
    const crop = canvas(square, square);
    crop.getContext("2d").drawImage(poster, (poster.width - square) / 2, (poster.height - square) / 2, square, square, 0, 0, square, square);
    context.save();
    quadPath(context, scene.vis);
    context.clip();
    if (GLR) {
      const texture = GLR.makeTexture(crop);
      const rendered = GLR.render(output.width, output.height, [{ texture, quad: scene.full, shade: 1 }]);
      context.drawImage(rendered, 0, 0);
      GLR.gl.deleteTexture(texture);
    } else {
      stripWarp(context, crop, scene.full[0][0], scene.full[1][0], scene.full[0][1], scene.full[1][1], scene.full[3][1], scene.full[2][1]);
    }
    context.filter = `brightness(${(255 / scene.wp).toFixed(3)})`;
    context.globalCompositeOperation = "multiply";
    context.drawImage(background, 0, 0, output.width, output.height);
    context.restore();
    return output;
  }

  function canvasUrl(item) {
    return new Promise((resolve, reject) => {
      item.toBlob((blob) => {
        if (!blob) reject(new Error("This device could not export a preview."));
        else resolve(URL.createObjectURL(blob));
      }, "image/jpeg", .84);
    });
  }

  function loadPoster(file) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      const url = URL.createObjectURL(file);
      image.onload = () => {
        URL.revokeObjectURL(url);
        const scale = Math.min(1, RENDER_MAX_SIDE / Math.max(image.naturalWidth, image.naturalHeight));
        const output = canvas(Math.round(image.naturalWidth * scale), Math.round(image.naturalHeight * scale));
        output.getContext("2d").drawImage(image, 0, 0, output.width, output.height);
        resolve(output);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error("That image could not be opened."));
      };
      image.src = url;
    });
  }

  function randomId() {
    if (crypto.randomUUID) return crypto.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  }

  async function createMockups(file, root, onProgress = () => {}) {
    const poster = await loadPoster(file);
    const posterOrientation = orientation(poster);
    const assets = assetsForOrientation(assetMap(root), posterOrientation);
    await waitForAssets(assets);
    const definitions = [
      ["Original flat", () => renderFlat(poster)],
      ["Room mockup", () => renderPhotoScene(poster, assets, "room")],
      ["Floor frame", () => renderPhotoScene(poster, assets, "floor")],
      ["Branded white", () => renderBranded(poster, assets)],
      ["Framed perspective", () => renderWrap(poster)],
      ...EXTRA_SCENES.map((scene) => [
        scene.label,
        () => scene.key === "tube"
          ? renderTube(poster, assets, scene)
          : renderFloater(poster, assets, scene),
      ]),
    ];
    const items = [];
    for (let index = 0; index < definitions.length; index += 1) {
      const [label, renderCanvas] = definitions[index];
      const url = await canvasUrl(renderCanvas());
      items.push({ label, url });
      onProgress({ completed: items.length, total: definitions.length, label });
      await new Promise((resolve) => requestAnimationFrame(resolve));
    }
    return {
      orientation: posterOrientation,
      width: poster.width,
      height: poster.height,
      items,
    };
  }

  function assetMap(root) {
    return [...root.querySelectorAll("[data-tn-asset]")].reduce((map, image) => {
      map[image.dataset.tnAsset] = image;
      return map;
    }, {});
  }

  function assetsForOrientation(assets, posterOrientation) {
    const keys = [
      "logo",
      `room.${posterOrientation}`,
      `floor.${posterOrientation}`,
      "tube",
      ...["white", "walnut", "gold", "natural", "black", "oak"].map(
        (color) => `floater-${color}.${posterOrientation}`,
      ),
    ];
    return keys.reduce((selected, key) => {
      if (assets[key]) selected[key] = assets[key];
      return selected;
    }, {});
  }

  function waitForAssets(assets) {
    return Promise.all(Object.values(assets).map((image) => {
      if (!image.getAttribute("src") && image.dataset.tnSrc) {
        image.src = image.dataset.tnSrc;
      }
      if (image.complete && image.naturalWidth) return Promise.resolve();
      return new Promise((resolve, reject) => {
        image.addEventListener("load", resolve, { once: true });
        image.addEventListener("error", () => reject(new Error("A mockup scene could not be loaded.")), { once: true });
      });
    }));
  }

  async function saveOriginal(root, file, uploadId) {
    const base = (root.dataset.uploadEndpoint || "").replace(/\/+$/, "");
    if (!base) return { localOnly: true };
    const response = await fetch(`${base}/api/uploads`, {
      method: "POST",
      headers: {
        "Content-Type": file.type || "application/octet-stream",
        "X-Upload-Id": uploadId,
        "X-File-Name": encodeURIComponent(file.name),
        "X-Page-Url": encodeURIComponent(location.href),
      },
      body: file,
    });
    if (!response.ok) throw new Error(`Private upload inbox returned ${response.status}.`);
    return response.json();
  }

  function init(root) {
    const fileInput = root.querySelector("[data-tn-file]");
    const drop = root.querySelector("[data-tn-drop]");
    const status = root.querySelector("[data-tn-status]");
    const progress = root.querySelector("[data-tn-progress]");
    const fileMeta = root.querySelector("[data-tn-file-meta]");
    const fileThumb = root.querySelector("[data-tn-file-thumb]");
    const fileName = root.querySelector("[data-tn-file-name]");
    const fileDetail = root.querySelector("[data-tn-file-detail]");
    const counter = root.querySelector("[data-tn-counter]");
    const thumbs = root.querySelector("[data-tn-thumbs]");
    const main = root.querySelector("[data-tn-main]");
    const empty = root.querySelector("[data-tn-empty]");
    const stageLabel = root.querySelector("[data-tn-stage-label]");
    const activeName = root.querySelector("[data-tn-active-name]");
    const activeCount = root.querySelector("[data-tn-active-count]");
    const addButton = root.querySelector("[data-tn-add]");
    const uploadProperty = root.querySelector("[data-tn-upload-property]");
    const assets = assetMap(root);
    let urls = [];
    let active = 0;
    let uploadId = "";
    let originalSaved = false;

    const setStatus = (text, tone = "") => {
      status.textContent = text;
      status.dataset.tone = tone;
    };

    const show = (index) => {
      if (!urls[index]) return;
      active = index;
      main.src = urls[index].url;
      main.alt = urls[index].label;
      main.hidden = false;
      empty.hidden = true;
      stageLabel.hidden = false;
      activeName.textContent = urls[index].label;
      activeCount.textContent = `${index + 1} / 12`;
      [...thumbs.children].forEach((button, buttonIndex) => button.classList.toggle("is-active", buttonIndex === index));
    };

    const addPreview = async (label, output) => {
      const url = await canvasUrl(output);
      urls.push({ label, url });
      const button = document.createElement("button");
      button.className = "tn-thumb";
      button.type = "button";
      button.setAttribute("aria-label", `Show ${label}`);
      button.innerHTML = `<img src="${url}" alt=""><span>${urls.length}</span>`;
      button.addEventListener("click", () => show([...thumbs.children].indexOf(button)));
      thumbs.appendChild(button);
      counter.textContent = `${urls.length} / 12 ready`;
      progress.style.width = `${Math.round((urls.length / 12) * 100)}%`;
      if (urls.length === 1) show(0);
      await new Promise((resolve) => requestAnimationFrame(resolve));
    };

    const handle = async (file) => {
      if (!file) return;
      if (!/^image\/(jpeg|png|webp)$/i.test(file.type)) {
        setStatus("Please choose a JPG, PNG, or WebP image.", "bad");
        return;
      }
      if (file.size > MAX_UPLOAD_BYTES) {
        setStatus("That file is larger than 25 MB. Please use a smaller copy.", "bad");
        return;
      }
      urls.forEach((item) => URL.revokeObjectURL(item.url));
      urls = [];
      thumbs.innerHTML = "";
      main.hidden = true;
      empty.hidden = false;
      stageLabel.hidden = true;
      progress.style.width = "2%";
      counter.textContent = "0 / 12 ready";
      addButton.disabled = true;
      originalSaved = false;
      uploadId = randomId();
      if (uploadProperty) uploadProperty.value = uploadId;
      fileThumb.src = URL.createObjectURL(file);
      fileName.textContent = file.name;
      fileDetail.textContent = `${(file.size / 1048576).toFixed(1)} MB`;
      fileMeta.classList.add("is-visible");
      setStatus("Securely saving your original and preparing previews…");
      try {
        const posterPromise = loadPoster(file);
        const savePromise = saveOriginal(root, file, uploadId)
          .then((result) => {
            originalSaved = !result.localOnly;
            return result;
          })
          .catch((error) => ({ error }));
        await waitForAssets(assets);
        const poster = await posterPromise;
        fileDetail.textContent += ` · ${poster.width} × ${poster.height} · ${orientation(poster)}`;
        await addPreview("Original flat", renderFlat(poster));
        await addPreview("Room mockup", renderPhotoScene(poster, assets, "room"));
        await addPreview("Floor frame", renderPhotoScene(poster, assets, "floor"));
        await addPreview("Branded white", renderBranded(poster, assets));
        await addPreview("Framed perspective", renderWrap(poster));
        for (const scene of EXTRA_SCENES) {
          await addPreview(scene.label, scene.key === "tube" ? renderTube(poster, assets, scene) : renderFloater(poster, assets, scene));
        }
        const saveResult = await savePromise;
        if (saveResult.error) {
          setStatus("Your previews are ready, but the private order inbox is offline. Please try again before ordering.", "bad");
          addButton.disabled = true;
        } else {
          setStatus(originalSaved ? "All 12 previews are ready and your original is safely saved." : "All 12 previews are ready. Demo mode: no private inbox is configured.", originalSaved ? "good" : "");
          addButton.disabled = false;
        }
      } catch (error) {
        setStatus(error.message || "We could not create the previews. Please try another image.", "bad");
        addButton.disabled = true;
      }
    };

    fileInput.addEventListener("change", () => handle(fileInput.files[0]));
    ["dragenter", "dragover"].forEach((type) => drop.addEventListener(type, (event) => {
      event.preventDefault();
      drop.classList.add("is-dragging");
    }));
    ["dragleave", "drop"].forEach((type) => drop.addEventListener(type, (event) => {
      event.preventDefault();
      drop.classList.remove("is-dragging");
    }));
    drop.addEventListener("drop", (event) => handle(event.dataTransfer.files[0]));
    addButton.addEventListener("click", () => {
      const form = root.querySelector("[data-tn-product-form]");
      if (form) form.requestSubmit();
      else setStatus(`Demo cart action ready. Upload ID: ${uploadId}`, "good");
    });
  }

  window.TNPosterRenderer = {
    createMockups,
    randomId,
  };

  document.querySelectorAll("[data-tn-customizer]").forEach(init);
})();
